import { Outlet } from 'react-router-dom';

import { NavbarLayout } from '@/app/components/layouts/navbar-layout';
import { useSyncCurrentOrgWithUserOrgs } from '@/features/org/hooks/use-current-org-id';
import { useResetOnOrgChange } from '@/features/org/hooks/use-reset-on-org-change';

export const AppRoot = () => {
  useSyncCurrentOrgWithUserOrgs();
  useResetOnOrgChange();
  return (
    <NavbarLayout>
      <Outlet />
    </NavbarLayout>
  );
};

export const AppRootErrorBoundary = () => {
  return <div>Something went wrong!</div>;
};
